import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=2bde1c63&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=2bde1c63&lang=scss&scoped=true&"
import style1 from "./Navigation.vue?vue&type=style&index=1&id=2bde1c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde1c63",
  null
  
)

export default component.exports